import React, { useEffect } from 'react';

const RequestOnApi = (props) => {
    
    const {
            setResponseObj,
            url,
            headers,
            params,
            bodyParams,
            clickedSend,
            setClickedSend,
            setResponseStatusCode,
            setResponseStatusMessage,
            typeRequest
        } = props; 


   const makeRequest = () => {

        const esc = encodeURIComponent;
        let query = '';
        params.forEach( (param, index) => {
            if(param[0] !== ''){
                query = `${query}${esc(param[0])}=${esc(param[1])}`;
            }  
            if(params[0] !== '' && index !==  params.length-1 && index !== params.length-2){
                query = `${query}&`;
            }
        })

        const queryHeaders = {};
        headers.forEach( (header) => {
            if(header[0] !== ''){
                const [header0, header1] = header; 
                queryHeaders[header0] = header1;
            }
        })

        const queryBodyParams = {};
        if(typeRequest === 'PUT' || typeRequest === 'POST'){
            bodyParams.forEach( (bodyParam) =>{
                if(bodyParam[0] !== ''){
                    const [bodyParam0, bodyParam1] = bodyParam;
                    queryBodyParams[bodyParam0] = bodyParam1;
                }
            })
        }
        

        /*  Example queries
        1. Get query
        
            fetch("https://jsonplaceholder.typicode.com/posts/1", {
                "method": 'GET',
                
            })
            .then(response => 
                response.json().then(data => {
                    setResponseStatusCode(response.status);
                    setResponseStatusMessage(response.statusText);
                    setResponseObj(data);
                })
            )
        
            fetch("https://community-open-weather-map.p.rapidapi.com/weather?q=London", {
                "method": 'GET',
                "headers": {
                "x-rapidapi-key":  "63021ae113msh16ac86cc708ed27p1c0b5bjsn286e47bcb127",
                "x-rapidapi-host": "community-open-weather-map.p.rapidapi.com"
                }
            })
            .then(response => 
                response.json().then(data => {
                    setResponseStatusCode(response.status);
                    setResponseStatusMessage(response.statusText);
                    setResponseObj(data);
                })
            )
        
        2. Post query
        
        
            fetch('https://jsonplaceholder.typicode.com/posts', {
            method: 'POST',
            body: JSON.stringify({
                title: 'foo',
                body: 'bar',
                userId: 1,
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
            })
            .then(response => 
                response.json().then(data => {
                    console.log(data);
                    console.log(response.status);
                    setResponseStatusCode(response.status);
                    setResponseStatusMessage(response.statusText);
                    setResponseObj(data);
                })
            )
        
        3. PUT query
        
            fetch('https://jsonplaceholder.typicode.com/posts/1', {
            method: 'PUT',
            body: JSON.stringify({
                id: 1,
                title: 'foo',
                body: 'bar',
                userId: 1,
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
            })
            .then(response => 
                response.json().then(data => {
                    console.log(response);
                    console.log(data);
                    setResponseStatusCode(response.status);
                    setResponseStatusMessage(response.statusText);
                    setResponseObj(data);
                })
            )
        
        4 Delete query
         
            fetch('https://jsonplaceholder.typicode.com/posts/1', {
                method: 'DELETE',
            })
            .then(response => 
                response.json().then(data => {
                    console.log(response);
                    console.log(data);
                    setResponseStatusCode(response.status);
                    setResponseStatusMessage(response.statusText);
                    setResponseObj(data);
                })
            );
        */
        
        if(typeRequest === 'POST' || typeRequest === 'PUT'){
            fetch(url,{
                method: typeRequest,
                body: JSON.stringify(queryBodyParams),
                headers: queryHeaders,
            })
            .then(response => 
                response.json().then(data => {
                    setResponseStatusCode(response.status);
                    setResponseStatusMessage(response.statusText);
                    setResponseObj(data);
                })
            )
        }
        
        else if(typeRequest === 'DELETE' || typeRequest === 'GET'){
            fetch(`${url}?${query}`,{
                "method": typeRequest,
                "headers": queryHeaders
            })
            .then(response => 
                response.json().then(data => {
                    setResponseStatusCode(response.status);
                    setResponseStatusMessage(response.statusText);
                    setResponseObj(data);
                })
            )
        }    
    }

   useEffect( () => {
       if(clickedSend === true){
            makeRequest();
            setClickedSend(false);
       }
   });
   return (
    <>
    </>
   )
}

export default RequestOnApi;